import { defineStore } from 'pinia';

export const useTableLayoutSettingsStore = defineStore('tableLayoutSettings', {
  state: () => ({
    stripedRows: false, // Rows with alternating background color
    cellGrid: true, // Show or hide cell grid
    checkboxMultiselect: true, // Checkbox-Multiselect aktiviere
    footerPagination: false, // Zeige Pagination im Footer
    instantEdit: false, // Single click to enter edit mode
  }),
  actions: {
    setStripedRows(value: boolean) {
      this.stripedRows = value;
    },
    setCellGrid(value: boolean) {
      this.cellGrid = value;
    },
    setCheckboxMultiselect(value: boolean) {
      this.checkboxMultiselect = value;
    },
    setFooterPagination(value: boolean) {
      this.footerPagination = value;
    },
    setInstantEdit(value: boolean) {
      this.instantEdit = value;
    },
  },
  persist: {
    storage: localStorage,
  },
});
